// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

// Sort instant search suggestion results: in-stock products appear before out-of-stock.
// Boost PFS sets xhr.onload before xhr.send(), so we wrap onload inside send().
(function () {
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && url.indexOf('bc-sf-filter/search/suggest') !== -1) {
      this._boostSuggest = true;
    }
    return origOpen.apply(this, arguments);
  };

  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    if (this._boostSuggest) {
      var xhr = this;
      var origOnLoad = xhr.onload;
      xhr.onload = function () {
        if (xhr.status === 200) {
          try {
            var data = JSON.parse(xhr.responseText);
            if (data.products && Array.isArray(data.products)) {
              data.products.sort(function (a, b) {
                return (b.available ? 1 : 0) - (a.available ? 1 : 0);
              });
              var sorted = JSON.stringify(data);
              Object.defineProperty(xhr, 'responseText', {
                get: function () { return sorted; },
                configurable: true
              });
              Object.defineProperty(xhr, 'response', {
                get: function () { return sorted; },
                configurable: true
              });
            }
          } catch (e) {}
        }
        if (origOnLoad) origOnLoad.call(this);
      };
    }
    return origSend.apply(this, arguments);
  };
})();

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if (!suggestionElement) suggestionElement = this.suggestionElement;
    if (!searchElement) searchElement = this.searchElement;
    if (!searchBoxId) searchBoxId = this.searchBoxId;

    if (jQ('.fancybox-overlay').length > 0) {
      jQ(suggestionElement).parent().css({
        'position': 'fixed',
      });
      jQ(suggestionElement).css({
        'overflow-y': 'scroll',
        'height': '300px'
      });
    }
  };

})();